<template>
  <div class="chart"><VueC3 :handler="chartHandler" /></div>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import C3Wrapper from '@/middlewares/C3Wrapper/C3Wrapper'
import { revenueBuyingCurrencyFormat } from '@/middlewares/numberFormat'

export default {
  name: 'Chart',
  components: { VueC3 },
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    chartHandler: new Vue(),
  }),
  watch: {
    chartData() {
      const chartItem = {
        name: 'revenueBuyingCurrency',
        displayName: '消化予算',
        format: revenueBuyingCurrencyFormat,
      }

      const budgetItem = {
        name: 'targetBudget',
        displayName: '目標予算',
        format: revenueBuyingCurrencyFormat,
      }

      const xAxisName = 'reportDate'
      this.chartHandler.$emit(
        'init',
        C3Wrapper.groupedBar({
          json: this.chartData,
          chartItem,
          budgetItem,
          xAxisName,
        }),
      )
    },
  },
}
</script>

<style scoped lang="scss">
$chart-grey: #dedede;

.chart {
  ::v-deep .c3-shapes-targetBudget {
    .c3-shape {
      fill: $chart-grey !important;
    }
  }

  ::v-deep .c3-tooltip-name--targetBudget .name span {
    background-color: $chart-grey !important;
  }
}
</style>
